// src/utils/loadComponent.js
export const globalForms = [
  "energy",
  "noc",
  "septic_system_repair",
  "septic_site_evaluation",
  "septic_construction_permit",
  "septic_worksheet",
  "noc_affidavit",
  "pp_ntbo",
  "pp_pca",
  "pp_pca_review_sheet",
];

export const privateProviderForms = [
  "pp_ntbo",
  "pp_pca",
  "pp_pca_review_sheet",
  "pp_ntbo_cover_sheet",
  "pp_pca_cover_sheet",
];

// export const permitMapping = {
//   building_permit: ["CGC", "CBC", "CRC", "RG", "RB", "RR", "SCC", "CPC", "TTT"],
//   electrical_permit: ["EC", "ER", "TTT"],
//   fire_permit: ["EF", "TTT"],
//   mechanical_permit: [
//     "CMC",
//     "RM",
//     "CGC",
//     "CBC",
//     "CRC",
//     "RG",
//     "RB",
//     "RR",
//     "CAC", // INCLUDED CAC LICENSE
//     "TTT",
//   ],
//   mobile_home_permit: ["CGC", "RG", "CRC", "RR", "TTT"],
//   plumbing_permit: ["CFC", "RF", "TTT"],
//   right_of_way_permit: ["CUC", "RU", "CGC", "RG", "TTT"],
//   roofing_permit: ["CCC", "RC", "TTT"],
//   sign_permit: ["ES", "TTT"],
//   sitework_permit: ["CUC", "RU", "CGC", "TTT"],
//   // Ensure Generator Permit can see a broad set (covers electrical + mechanical + general + demo)
//   generator_permit: [
//     "EC",
//     "ER",
//     "CMC",
//     "RM",
//     "CGC",
//     "CBC",
//     "CRC",
//     "RG",
//     "RB",
//     "RR",
//     "CFC",
//     "RF",
//     "CUC",
//     "RU",
//     "CCC",
//     "RC",
//     "ES",
//     "EF",
//     "TTT",
//   ],
// };

export const ntboRelations = ["pp_ntbo_cover_sheet", "pp_ntbo"];

export const pcaRelations = [
  "pp_pca_cover_sheet",
  "pp_pca",
  "pp_pca_review_sheet",
];

export const countySpecificForms = {
  broward: ["building_permit", "water_heater"],
  charlotte: ["cost_worksheet", "damage_affidavit"],
  clay: ["building_permit", "builder_disclosure", "owner_permission"],
  collier: [
    "substantial_imp_application",
    "substantial_imp_contractor_affidavit",
    "substantial_imp_owner_affidavit",
    "pp_ntbo",
  ],
  lee: [
    "contractor_affidavit",
    "cost_form",
    "cost_worksheet",
    "owner_affidavit",
    "scope_of_work",
  ],
  manatee: [
    "cost_worksheet",
    "improvement_disclosure",
    "substantial_contractor_affidavit",
    "substantial_review",
  ],
  nassau: ["pass", "roofing"],
  sarasota: ["contractor_affidavit", "cost_worksheet", "damage_worksheet"],
  st_johns: [
    "building_permit",
    "clearance_sheet",
    "demolition",
    "electrical_permit",
    "gas_permit",
    "generator_worksheet",
    "pass",
    "private_provider",
    "renovations",
    "sunroom",
  ],
};

export const contractorDisableNames = [
  "contractorBusiness",
  "contractorName",
  "contractorAddress",
  "contractorStreet",
  "contractorCounty",
  "contractorLicense",
  "contractorEmail",
  "contractorPhone",
];

export const productApprovalFields = ["pais_num", "product_approval_num"];

export const productApprovalSections = [
  {
    name: "New Roof Data",
    roof_1: {
      label: "Roof 1",
      fields: [
        { field: "pais_covering", label: "Covering" },
        { field: "pais_underlay", label: "Underlay" },
        { field: "pais_slope", label: "Slope" },
      ],
    },
    roof_2: {
      label: "Roof 2",
      fields: [
        { field: "pais_covering_2", label: "Covering" },
        { field: "pais_underlay_2", label: "Underlay" },
        { field: "pais_slope_2", label: "Slope" },
      ],
    },
  },
  {
    name: "Product Approval",
    roof_1: {
      label: "Categories",
      fields: [
        { field: "pais_window", label: "Window" },
        { field: "pais_shutter", label: "Shutters" },
      ],
    },
  },
];

export const fillProductFields = [
  "pais_num",
  "pais_man",
  "pais_desc",
  "pais_use",
  "product_approval_num",
];

export const productInsertionMap = (fieldName, selectedProductRow) => {
  const fields = {
    pais_num: `FL${selectedProductRow?.sub_fl_number}`,
    product_approval_num: `FL${selectedProductRow?.sub_fl_number}`,
    pais_man: selectedProductRow?.product_manufacturer,
    pais_desc: selectedProductRow?.sub_description,
    pais_use: selectedProductRow?.sub_expiration_date,
  };
  return fields[fieldName];
};

export const initials = {
  signeeInitial: [
    "property_owner?.personalName",
    "property_owner?.name",
  ],
};

export const extract_legal_parts_fields = [
  "lot",
  "subdivision",
  "block",
  "platted",
];

export const unitNumMapping = {
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
};

export const filter_number_input_values = [
  { parentName: "num_units", formValue: "unit_" },
  { parentName: "soil_prof_a_num", formValue: "soil_prof_a_" },
  { parentName: "soil_prof_b_num", formValue: "soil_prof_b_" },
];

export const canvasForms = {
  septic_worksheet: {
    btnLabel: "CREATE SITE PLAN",
    canvasLabel: "Create Site Plan",
    btnLabelEdit: "EDIT SITE PLAN",
    canvasLabelEdit: "Edit Site Plan",
  },
  window_worksheet: {
    btnLabel: "CREATE WINDOW WORKSHEET",
    canvasLabel: "Create Window Worksheet",
    btnLabelEdit: "EDIT WINDOW WORKSHEET",
    canvasLabelEdit: "Edit Window Worksheet",
  },
};

export const fieldsToCheckProject = ["project_contact", "project_c_phone"];
export const fieldsToCheckFeeSimple = ["fee_simple_name", "fee_simple_address"];

export const fieldsToCheckBonding = ["bonding_name", "bonding_address"];
export const fieldsToCheckMortgage = ["mortgage_name", "mortgage_address"];
export const fieldsToCheckTermite = ["protection_by"];
export const fieldsToCheckPrivateProvider = [
  "pp_company_name",
  "pp_address",
  "pp_phone",
  "pp_email",
  "pp_name",
  "pp_license",
];

export const feeSimpleMapping = {
  nameField: "fee_simple_name",
  addressField: "fee_simple_address",
  labels: {
    feeSimple: "Fee Simple",
    feeSimpleAddress: "Fee Simple Address",
  },
};

export const bondingMapping = {
  nameField: "bonding_name",
  addressField: "bonding_address",
  labels: {
    surety: "Surety",
    suretyAddress: "Surety Address",
  },
};

export const mortgageMapping = {
  nameField: "mortgage_name",
  addressField: "mortgage_address",
  labels: {
    mortgage: "Surety",
    mortgageAddress: "Surety Address",
  },
};

export const hiddenFields = [
  "pp_company_name",
  "pp_address",
  "pp_phone",
  "pp_email",
  "pp_name",
  "pp_license",
  "project_contact",
  "project_c_phone",
  "design_pro_company",
  "design_pro_license_name",
  "design_pro_license_num",
  "design_pro_address",
  "design_pro_phone",
  "design_pro_fax",
  "design_pro_email",
  "fee_simple_name",
  "fee_simple_address",
  "bonding_name",
  "bonding_address",
  "mortgage_name",
  "mortgage_address",
];

export const totalFields = ["totalCost"];
